import { BaseWebComponentView } from '../../framework/BaseWebComponentView';
import { CompanySelectorWebComponentSchema } from '../types';
import { ErrorDialogStrings } from '../../types';
import { mergeTargets } from '../../utils/company.selector.utils';

export class CompanySelectorView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$companySelectorDropdown = this.shadow.querySelector('#companySelectorDropdown');

    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.dom.$companySelectorDropdown.setAttribute('noResultsFound', this.commonStrings.noResultsFound);
    this.dom.$companySelectorDropdown.setAttribute('errorMessage', this.commonStrings.genericError);
  }

  buildSuccessView(data: CompanySelectorWebComponentSchema) {
    if (!data) {
      this.dom.$wrapper.innerHTML = '';
      return;
    }
    const { disabled, label, placeholder } = data;
    let { selectedTarget } = data;
    if (this.dependencies.selectedCompany) {
      selectedTarget = this.dependencies.selectedCompany;
    }
    // It can be possible that selected targets are not in the list of returned targets. I.e., targets is some
    // 10 companies, and the selected target is another company. In this case, we want to add the company selected
    // to the list of all available companies. Hence, merging is required.
    const availableCompanies = mergeTargets(data.availableCompanies, [selectedTarget]);

    this.dom.$companySelectorDropdown.disabled = disabled;

    const companyOptions = availableCompanies.map(availableCompany => {
      return {
        title: availableCompany.companyName || "",
        value: availableCompany.companyId || "",
      };
    });

    this.dom.$companySelectorDropdown.setAttribute('options', JSON.stringify(companyOptions));
    this.dom.$companySelectorDropdown.setAttribute('value', selectedTarget.companyId || '');
    this.dom.$companySelectorDropdown.setAttribute('label', label || '');
    this.dom.$companySelectorDropdown.setAttribute('placeholder', placeholder || '');
  }

  clearInput() {
    this.dom.$companySelectorDropdown.clearInput();
  }

  public showErrorDialog(companyName: string) {
    const dialogStrings = this.stringsTranslator.getDialogStrings();
    const { loadingErrorTitle, genericErrorMessage, confirm } = dialogStrings;
    const message = companyName ? this.getCompanyNameInSelectorErrorMessage(companyName) : genericErrorMessage;

    const strings: ErrorDialogStrings = {
      title: loadingErrorTitle,
      message: message,
      actionButtonString: confirm,
    };

    this.buildDialogElement(strings);
  }

  private getCompanyNameInSelectorErrorMessage(companyName: string): string {
    return this.dependencies.translateFn(
      'An internal error occurred when selecting the company {name}. Please try again later or contact Bitdefender Enterprise Support if the issue persists.',
      {
        name: companyName,
      }
    );
  }
}
